export type environment =
  | 'LOCAL'
  | 'DEV'
  | 'DEV1'
  | 'DEV2'
  | 'TEST'
  | 'QA'
  | 'QA1'
  | 'QA2'
  | 'QA4'
  | 'CERT'
  | 'UAT'
  | 'IP'
  | 'SUPPORT'
  | 'STAGE'
  | 'TRAINING'
  | 'PRIOR'
  | 'PROD';

export const LOCAL = 'LOCAL';
export const DEV = 'DEV';
export const DEV1 = 'DEV1';
export const DEV2 = 'DEV2';
export const TEST = 'TEST';
export const QA = 'QA';
export const QA1 = 'QA1';
export const QA2 = 'QA2';
export const QA4 = 'QA4';
export const CERT = 'CERT';
export const UAT = 'UAT';
export const IP = 'IP';
export const SUPPORT = 'SUPPORT';
export const STAGE = 'STAGE';
export const TRAINING = 'TRAINING';
export const PRIOR = 'PRIOR';
export const PROD = 'PROD';

export const environments: {
  [url: string]: environment;
} = {
  'localhost:3000': LOCAL,
  'dev.agentnetportal.firstam.net': DEV,
  'env1.dev.agentnetportal.firstam.net': DEV1,
  'env2.dev.agentnetportal.firstam.net': DEV2,
  'test.agentnetportal.firstam.net': TEST,
  'qa.agentnetportal.firstam.net': QA,
  'env1.qa.agentnetportal.firstam.net': QA1,
  'env2.qa.agentnetportal.firstam.net': QA2,
  'env4.qa.agentnetportal.firstam.net': QA4,
  'cert.agentnetportal.firstam.net': CERT,
  'uat.agentnetportal.firstam.net': UAT,
  'ip.agentnetportal.firstam.com': IP,
  'support.agentnetportal.firstam.net': SUPPORT,
  'stage.agentnetportal.firstam.net': STAGE,
  'training.agentnetportal.firstam.net': TRAINING,
  'prior.agentnetportal.firstam.net': PRIOR,
  'agentnet.firstam.com': PROD,
};

export const launchDarklyClientSideId: {
  [environment: string]: string;
} = {
  LOCAL: '673be5b0deb09e088eef2ee6',
  DEV1: '673be5b0deb09e088eef2ee6',
  DEV2: '673be60b6a1d310844325915',
  QA1: '673be5fc615a64081061fa2e',
  QA2: '673be605beaa24088a1b9b36',
  CERT: '6806873f20748e08a73fae2b',
  IP: '673be6111d3d5e085676f392',
  SUPPORT: '6806868eb18aa908e198a99c',
  STAGE: '6806863220748e08a73fa0b1',
  TRAINING: '68068601da547c093dfed947',
  PRIOR: '6806864442dea508d71f34ff',
  PROD: '673be55506c5ad0839259be7',
};

/**
 * Returns the current environment name based on the webpage's host.
 *
 * @returns {environment} env - the environment name.
 * @default DEV
 */
const resolveEnv = (): environment => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const apiHostname = window.location.host;

  return environments[apiHostname] || DEV;
};

export default resolveEnv;
